// import { transparentize } from "polished";
import styled from "styled-components";

export const SidebarContainer = styled.aside<{
  isCollapsed: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  top: 0;
  min-width: 0;
  flex-grow: 0;
  flex-shrink: 0;
  height: 100%;
  background: ${(props) => props.theme.colors.bg1};
  border-right: 1px solid black;
  // border-top: 1px solid $ {(props) => props.theme.global.colors.border.normal};

  // & > *:first-child {
  //   margin-top: $ {(props) => props.theme.global.padding.medium};
  // }

  // & > *:last-child {
  //   margin-bottom: $ {(props) => props.theme.global.padding.medium};
  // }

  // & > $ {NavWrapper}:last-child {
  //   border-top: 0;
  // }
`;

export const HeadContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

export const ReservationText = styled.div`
  font-family: Helvetica Neue;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  /* identical to box height */

  color: #000000;
  margin-top: 20px;
  margin-left: 10px;
`;
